import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaFormatosGeneralesInterface } from "../../../../../interfaces/FechaFormatosGeneralesInterface";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { AutorizacionEvaluacionesListaPrint } from "./AutorizacionEvaluacionesListaPrint";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const AutorizacionEvaluacionesListaScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario =
    "AUTORIZACIÓN AL PROCESO DE EVALUACIONES DE PRUEBAS DE CONFIANZA";
  const [formData, setFormData] = useState({
    date: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, reset } = useForm();

  const queryFechaFG = useGetData<FechaFormatosGeneralesInterface>({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const handlePrint = () => {
    const printContent = document.getElementById("printableContent");

    if (printContent) {
      const printWindow = window.open("", "", "width=800,height=600");

      if (printWindow) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Vista Previa de Impresión</title>
              <style>
                @media print {
                  body {
                    margin: 20px;
                    font-family: Arial, sans-serif;
                  }
                }
              </style>
            </head>
            <body>${printContent.innerHTML}</body>
          </html>
        `);

        const styles = document.styleSheets;
        for (let i = 0; i < styles.length; i++) {
          try {
            if (styles[i].cssRules) {
              const styleTag = printWindow.document.createElement("style");
              for (let j = 0; j < styles[i].cssRules.length; j++) {
                styleTag.appendChild(
                  printWindow.document.createTextNode(
                    styles[i].cssRules[j].cssText
                  )
                );
              }
              printWindow.document.head.appendChild(styleTag);
            }
          } catch (e) {
            console.warn("No se pudo copiar una hoja de estilo:", e);
          }
        }

        printWindow.document.close();
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 500);
        };
      } else {
        alert("No se pudo abrir la ventana de impresión.");
      }
    }
  };

  useEffect(() => {
    if (queryFechaFG.data) {
      const fechafg = queryFechaFG.data;
      reset({
        fecha_autorizacion_procesoevaluaciones:
          fechafg.fecha_autorizacion_procesoevaluaciones || "",
      });
    }
  }, [queryFechaFG.data, reset]);

  const navigate = useNavigate();

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`max-w-4xl mx-auto shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
        {/* Header */}
        <Header titulo={tituloFormulario} />

        {/* Contenido del formulario */}
        <div className="p-6">
          <div className="space-y-6">
            <div className="flex items-center space-x-2 mb-4">
              <p className={`mt-1 translate-y-1 whitespace-nowrap ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
                Ciudad de México a{" "}
                {queryFechaFG.data?.fecha_autorizacion_procesoevaluaciones
                  ? (() => {
                      const date = new Date(
                        queryFechaFG.data.fecha_autorizacion_procesoevaluaciones
                      );
                      date.setDate(date.getDate() + 1);
                      return date.toLocaleDateString("es-ES", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      });
                    })()
                  : "Fecha no disponible"}
              </p>
            </div>
            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <span className="mr-2">Yo{""}</span>
              <strong>{`${queryEvaluado.data?.nombre || ""} ${
                queryEvaluado.data?.apellido_paterno || ""
              } ${queryEvaluado.data?.apellido_materno || ""}`}</strong>{" "}
              autorizo que me apliquen todas las evaluacionesde Pruebas de
              confianza que consisten en:{" "}
            </p>

            <ol className={`list-decimal pl-5 text-justify leading-relaxed space-y-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <li>
                <strong>Evaluación Médica:</strong> Revisión, valoración,
                cuestionarios, historia clínica, entrevista, etc.
              </li>
              <li>
                <strong>Evaluación Psicológica:</strong> Aplicación de pruebas
                psicológicas y entrevista.
              </li>
              <li>
                <strong>Evaluación Poligráfica:</strong> Entrevista y examen
                poligráfico de ser el caso.
              </li>
              <li>
                <strong>Evaluación de Visita Domiciliaria:</strong> Visita al
                domicilio del evaluado, entrevista a evaluado, vecinos y
                familiares.
              </li>
              <li>
                <strong>Evaluación Toxicológica:</strong> Recolección de muestra
                para realizar reactivo de 6 elementos.
              </li>
              <li>
                <strong>
                  Evaluación de Pruebas Socioeconómicas y/o Patrimonial:
                </strong>{" "}
                Así como visita domiciliaria en caso de ser necesario.
              </li>
            </ol>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <strong>VERIFICACIÓN DOCUMENTAL:</strong> Entrega de documentos
              necesarios para la conformación del expediente; así como la
              validación de documentos.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <strong>INVESTIGACIÓN ANTECEDENTES:</strong> Verificación de
              antecedentes registrales de tipo penal, administrativo, laboral,
              patrimonial, económico y de referencias; mediante la utilización de
              sistemas automatizados de identificación, fuentes abiertas, públicas
              y oficiales, así como, la consulta en bases estatales y federales, y
              la investigación específica ante instituciones competentes de los
              tres niveles de gobierno que puedan proporcionar información de los
              antecedentes referidos. En su caso grabado de voz, toma de
              fotografía y huellas decadactilares.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              <strong>PRUEBAS SOCIOECONÓMICA Y/O PATRIMONIALES:</strong> Llenado
              de cuestionarios, entrevista si el caso lo amerita, indagar sobre el
              ambiente social, familiar, nivel de vida, trayectoria académica,
              laboral, profesional y visita domiciliaria.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Asimismo, autorizo a la empresa SKA TRACKING AND SECURITY S.A. de
              C.V. para que proporcione toda la información y documentación que
              derive de las evaluaciones de pruebas de confianza que me realicen.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              En este acto autorizo y conozco el aviso de privacidad el cual se
              encuentra publicado en
              https://skyangel.com.mx/avisodeprivacidad.htim, por lo cual en este
              acto consiento que SKA TRACKING AND SECURITY S.A. de C.V. podrá
              recabar mis datos personales de conformidad con los términos
              establecidos en dicho aviso.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Bajo protesta de decir verdad hago constar que los datos
              proporcionados en el proceso de evaluación son verdaderos.
            </p>
          </div>

          <div className={`flex flex-col items-center mt-4 w-full ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            <span className="font-medium text-center mb-12">ATENTAMENTE</span>
            <div className={`w-64 border-b-2 ${isDarkMode ? "border-gray-400" : "border-gray-800"}`} />
            <span className="text-center font-semibold mt-2">NOMBRE Y FIRMA</span>
          </div>
          <br />
          <br />
        </div>

        {/* Botones */}
        <div className="mt-4 mb-4 px-4">
          <div className="flex justify-between">
            <Button
              color="red"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(-1);
              }}
              className={`${isDarkMode ? "bg-red-600 hover:bg-red-700" : "bg-red-500 hover:bg-red-600 text-white"}`}
            >
              Regresar
            </Button>
            <Button
              color="blue"
              className={`z-10 ${isDarkMode ? "bg-blue-600 hover:bg-blue-700" : ""}`}
              onClick={handlePrint}
            >
              Imprimir
            </Button>
          </div>
        </div>

        {/* Footer */}
        <div className={`h-12 mt-8 flex items-center justify-center ${isDarkMode ? "bg-blue-800" : "bg-customBlue"}`}>
          <p className="text-sm text-white px-4">
            <span className="font-bold">DOCUMENTO CONFIDENCIAL</span>, prohibido
            su reproducción, copia o sacar este documento de las Instalaciones de
            Skyangel
          </p>
        </div>
        {/* Imprimir */}
        <div id="printableContent" style={{ display: "none" }}>
          <AutorizacionEvaluacionesListaPrint />
        </div>
      </div>
    </div>
  );
};